import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    container: 'relative w-full',
    trigger: 'heading-m flex h-[52px] cursor-pointer border-b bg-white px-4',
    value:
      'scrollbar-hidden flex max-w-full flex-1 flex-wrap gap-1 overflow-x-scroll pr-5',

    placeholder: 'text-secondary-hover leading-[52px]',
    iconArrow: 'mr-3',
    dropdown:
      'absolute right-0 left-0 z-60 max-h-[400px] overflow-y-auto bg-white p-2 shadow-md',
    optionRow: 'hover:bg-blue-light cursor-pointer px-4 py-3',
    selectedList: 'mb-2 flex flex-wrap gap-1 border-b border-gray-100 pb-2',
    selectedItem:
      'bg-blue-light flex items-center gap-1 rounded-full px-4 py-2 text-sm font-medium',
    removeBtn: 'ml-1 p-0.5 hover:text-red-500 focus:outline-none',
    searchContainer: 'relative mb-2',
    searchIcon: 'absolute top-1/2 left-4 -translate-y-1/2 text-gray-400',
    searchInput:
      'focus:border-primary w-full rounded-lg border border-gray-100 bg-gray-50 py-2 pr-4 pl-11 text-sm placeholder:text-gray-400 focus:outline-none',
    tags: 'flex gap-1 overflow-x-scroll',
    tag: 'bg-blue-light heading-s-bold flex h-10 min-w-fit items-center gap-2 rounded-[100px] pr-4 pl-2',
    closeIcon: 'flex-center flex h-[20px] w-[20px] rounded-full border'
  },
  variants: {
    open: {
      true: {
        iconArrow: '-rotate-90'
      },
      false: {
        iconArrow: 'rotate-90'
      }
    },
    disableClose: {
      true: {
        closeIcon:
          'flex-center pointer-events-none flex h-[20px] w-[20px] rounded-full border opacity-30'
      }
    }
  }
});
